import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { ISmartSendContext } from '../context/SmartSendContextModels';
import GenerateOptions from './SmartSendBulkActionOptions';
import { ApplierOption } from './ApplierOption';
import { GetSelectedItems } from './GetSelectedItems';
import { SanitiseStatus } from './SanitiseStatus';

export function SmartSendBulkStatusApplier(
  filterKey: string,
  state: ISmartSendContext,
  status: string,
  smartSendItemsCache: SmartSendItemApiModel[]
) {
  GetSelectedItems(filterKey, state, smartSendItemsCache)
    .filter((i) => GenerateOptions(i, i.State.validation).includes(`Status:${status}` as ApplierOption))
    .forEach((i) => {
      i.Status = SanitiseStatus(status);
      i.State.unsaved = ['Status'];
      i.State.state = 'SAVE';
    });
}
